import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Xmark } from '@gravity-ui/icons';
import './NewViolationBanner.css';

/**
 * In-app баннер «Новое нарушение». Кнопка «Открыть» — единственный переход;
 * автоматической смены текущей страницы пользователя быть не должно
 * (PART 3, раздел 6).
 */
const NewViolationBanner = ({ event, onDismiss }) => {
  const navigate = useNavigate();
  if (!event?.id) return null;

  const subtitle = [event.rule_name, event.camera_name].filter(Boolean).join(' · ');

  return (
    <div className="nvb" role="status">
      <span className="nvb-mark">!</span>
      <div className="nvb-text">
        <span className="nvb-title">Новое нарушение</span>
        {subtitle && <span className="nvb-sub">{subtitle}</span>}
      </div>
      <button
        type="button"
        className="nvb-open"
        onClick={() => { onDismiss(); navigate(`/violations/${event.id}`); }}
      >
        Открыть
      </button>
      <button type="button" className="nvb-close" aria-label="Закрыть" onClick={onDismiss}>
        <Xmark width={16} height={16} />
      </button>
    </div>
  );
};

export default NewViolationBanner;
